import React, { Component } from 'react'
import { graphql } from 'gatsby'

import Article from './article.template'
import Cluster from './cluster.template'
import Index from './index.template'
import List from './list.template'
import Pillar from './pillar.template'
import Podcast from './podcast.template'
import PressRelease from './press.template'
import Topic from './topic.template'

import VideoMetadata from '../content/videos'

export class Resource extends Component {
  render() {
    let {
      data: {
        markdownRemark: { frontmatter }
      }
    } = this.props
    let resource = null

    if (frontmatter.video) {
      frontmatter.video = VideoMetadata[frontmatter.video]
    }

    if (frontmatter && frontmatter.type) {
      switch (frontmatter.type) {
        case 'Article': {
          resource = <Article {...this.props} />
          break
        }
        case 'List': {
          resource = <List {...this.props} />
          break
        }
        case 'Topic': {
          resource = <Topic {...this.props} />
          break
        }
        case 'Cluster': {
          resource = <Cluster {...this.props} />
          break
        }
        case 'Pillar': {
          resource = <Pillar {...this.props} />
          break
        }
        case 'Index': {
          resource = <Index {...this.props} />
          break
        }
        case 'Podcast': {
          resource = <Podcast {...this.props} />
          break
        }
        case 'Press Release': {
          resource = <PressRelease {...this.props} />
          break
        }
        default: {
          resource = <Article {...this.props} />
          break
        }
      }
    }

    return resource
  }
}

export default Resource

export const resourceQuery = graphql`
  query ResourceQuery($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      id
      html
      excerpt
      timeToRead
      tableOfContents(maxDepth: 2)
      fields {
        slug
        tagSlugs
      }
      frontmatter {
        author
        banner {
          publicURL
          childImageSharp {
            fluid(maxWidth: 1080, quality: 90) {
              ...GatsbyImageSharpFluid_withWebp_noBase64
              presentationWidth
            }
          }
        }
        alt
        categories
        date
        description
        keywords
        steps
        tags
        title
        type
        video
        metaTitle
        socialTitle
        socialDescription
      }
    }
  }
`
